import { $ } from "@/plug/Axios";

export default {
  /**
   * 心理测试员工
   */
  employee_answer: {
    /*
     * 交卷
     * answerText JSON（id，answer） (string query required)
     * applyName 姓名 (string query required)
     * applyPosition 应聘岗位 (string query required)
     * paperId 试卷ID (integer query required)
     */
    post: (p, c) => $.post("/api/bms/mentalTest/employee/answer", p, c)
  },
  employee_getPaperDetail: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/mentalTest/employee/getPaperDetail", p, c)
  },
  employee_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/mentalTest/employee/list", p, c)
  },

  /**
   * 心理测试
   */
  paper_downloadMould: {
    /*
     * 下载习题导入模版
     */
    get: (p, c) => $.get("/api/bms/mentalTest/paper/downloadMould", p, c)
  },
  paper_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/mentalTest/paper/list", p, c)
  },
  paper_listExercise: {
    /*
     * 根据试卷id查询习题列表
     * ableStatus 启用禁用 (string query )
     * id paperId (integer query required)
     */
    get: (p, c) => $.get("/api/bms/mentalTest/paper/listExercise", p, c)
  },
  paper_listPaperForClient: {
    /*
     * C端试卷列表
     */
    get: (p, c) => $.get("/api/bms/mentalTest/paper/listPaperForClient", p, c)
  },
  paper_listPaperString: {
    /*
     * 简单试卷列表
     */
    get: (p, c) => $.get("/api/bms/mentalTest/paper/listPaperString", p, c)
  },
  paper_listSimplePaper: {
    /*
     * 简单试卷列表
     */
    get: (p, c) => $.get("/api/bms/mentalTest/paper/listSimplePaper", p, c)
  },
  paper_remove: {
    /*
     * 删除
     * id ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/mentalTest/paper/remove", p, c)
  },
  paper_removeExercise: {
    /*
     * 删除
     * id 习题列表的ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/mentalTest/paper/removeExercise", p, c)
  },
  paper_save: {
    /*
     * 添加编辑
     * creatorId  (integer query )
     * id  (integer query )
     * name 名称 (string query )
     * publishStatus 发布状态 (string query )
     * type 类型：菲尔测试|MBTI测试 (string query )
     */
    post: (p, c) => $.post("/api/bms/mentalTest/paper/save", p, c)
  },
  paper_saveExercise: {
    /*
     * 添加编辑习题
     * ableStatus 启用状态：启用，禁用 (string query )
     * answerA 答案A (string query )
     * answerB 答案B (string query )
     * answerC 答案C (string query )
     * answerD 答案D (string query )
     * answerE 答案E (string query )
     * answerF 答案F (string query )
     * answerG 答案G (string query )
     * content 题目 (string query )
     * hashValue  (string query )
     * id  (integer query )
     * scoreA 答案A得分 (string query )
     * scoreB 答案B得分 (string query )
     * scoreC 答案C得分 (string query )
     * scoreD 答案D得分 (string query )
     * scoreE 答案E得分 (string query )
     * scoreF 答案F得分 (string query )
     * scoreG 答案G得分 (string query )
     * sorting 排序 (integer query )
     * testPaperId 试卷ID (integer query )
     */
    post: (p, c) => $.post("/api/bms/mentalTest/paper/saveExercise", p, c)
  },
  paper_upload: {
    /*
     * 导入习题
     * excelFile excelFile (file formData required)
     * id ID (integer query required)
     */
    post: (p, c) => $.post("/api/bms/mentalTest/paper/upload", p, c)
  }
};
